module.exports = __webpack_public_path__ + "img/Phase2LOStep.e14f6c88.png";